// import { store } from '@/store/store'
import Layout from '@/container/Full'
import MigrationsView from '@/views/migrations/MigrationsView'
import MigrationView from '@/views/migrations/MigrationView'

const routes = [
  {
    path: '/migrations',
    name: '',
    component: Layout,
    children: [
      {
        path: '',
        name: 'migrations',
        component: MigrationsView,
        meta: {
          access_type: 'authorized',
        },
      },
      {
        name: 'migration_details',
        path: '/migrations/:id',
        component: MigrationView,
        meta: {
          access_type: 'authorized',
          breadcrumb: routeParams => `#${routeParams.id}`,
        },
      }
    ]
  }
]

export default routes
